import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BookingService {

  private selectedOfficeSubject = new BehaviorSubject<string[]>([]);
  selectedOffice$ = this.selectedOfficeSubject.asObservable();

  private selectedDatesSubject = new BehaviorSubject<Date[] | null>(null);
  selectedDates$ = this.selectedDatesSubject.asObservable();

  private selectedActivitySubject = new BehaviorSubject<string[]>([]);
  selectedActivity$ = this.selectedActivitySubject.asObservable();

  private selectedCapacitySubject = new BehaviorSubject<number[]>([]);
  selectedCapacity$ = this.selectedCapacitySubject.asObservable();

  private combinedSelectionSubject = new BehaviorSubject<{ offices: string[], services: string[], seats: number[], date: Date[] }>({ offices: [], services: [], seats: [], date: [] });
  combinedSelection$ = this.combinedSelectionSubject.asObservable();

  private activeIconSubject = new BehaviorSubject<string | null>(null);
  activeIcon$ = this.activeIconSubject.asObservable();

  private pendingAmountSubject = new BehaviorSubject<number>(0);
  public pendingAmount$: Observable<number> = this.pendingAmountSubject.asObservable();

  constructor() {}

  updatePendingAmount(newPendingAmount: number) {
    this.pendingAmountSubject.next(newPendingAmount);
  }

  updateCombinedSelection(combinedSelection: { offices: string[], services: string[], seats: number[], date: Date[] }) {
    this.combinedSelectionSubject.next(combinedSelection);
    this.updateSelectedOffice(combinedSelection.offices);
    this.updateSelectedActivity(combinedSelection.services);
    this.updateSelectedCapacity(combinedSelection.seats);
    this.updateSelectedDates(combinedSelection.date);
  }

  updateSelectedOffice(selectedOfficeToUpdate: string[]) {
    this.selectedOfficeSubject.next(selectedOfficeToUpdate);
  }

  updateSelectedDates(selectedDatesToUpdate: Date[] | null) {
    this.selectedDatesSubject.next(selectedDatesToUpdate);
  }

  updateSelectedActivity(selectedActivityToUpdate: string[]) {
    this.selectedActivitySubject.next(selectedActivityToUpdate);

    const currentOffices = this.selectedOfficeSubject.value;
    const currentDates = this.selectedDatesSubject.value ?? [];
    const currentCapacities = this.selectedCapacitySubject.value;

    this.combinedSelectionSubject.next({
      offices: currentOffices,
      services: selectedActivityToUpdate,
      seats: currentCapacities,
      date: currentDates
    });
  }

  updateSelectedCapacity(selectedCapacitiesToUpdate: number[]) {
    this.selectedCapacitySubject.next(selectedCapacitiesToUpdate);
  }

  updateActiveIcon(icon: string | null | undefined ) {
    if(icon) {
      this.activeIconSubject.next(icon.toString());
    }
  }

}
